
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"id":"Calque_1","data-name":"Calque 1","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 800 800"}, attrs),
              ...rest,
            },
            children.concat([_c('defs'),_c('title',[_v('p')]),_c('path',{staticClass:"cls-1",attrs:{"d":"M321.29,54.44H64.44a5,5,0,0,0-5,5V208.33a5,5,0,0,1-5,5H5a5,5,0,0,1-5-5V5A5,5,0,0,1,5,0H795a5,5,0,0,1,5,5V62.22h0V208.33a5,5,0,0,1-5,5H750.56a5,5,0,0,1-5-5V59.44a5,5,0,0,0-5-5H475.71a5,5,0,0,0-5,5V745.56a5,5,0,0,0,5,5H629.47a5,5,0,0,1,5,5V795a5,5,0,0,1-5,5H168.53a5,5,0,0,1-5-5V755.56a5,5,0,0,1,5-5H321.29a5,5,0,0,0,5-5V59.44A5,5,0,0,0,321.29,54.44Z"}})])
          )
        }
      }
    